// Common.
export const PleaseEnterValidDate = 'Please enter a valid date.';

// Non-Linear.
export const ExpireDateCompareWithPublishedDate = 'Expiry Date must be greater than or equal to Published Date.';
export const PublicationMandatoryFieldsMustBeEntered = 'Publication mandatory fields must be entered.';


// WEBPACK FOOTER //
// ./src/messages/businessMessages.js